import Tab from './tab.element.js';

export default Tab;

Tab.define('wje-tab', Tab);
